import script from "./SwitchBase.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchBase.vue?vue&type=script&setup=true&lang=js"

import "./SwitchBase.vue?vue&type=style&index=0&id=940de324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-940de324"]])

export default __exports__